import { FieldType, IFileDetails, LockStatus } from "../../../../models"
import { CaratechType, ITax } from "../../../../models/bo"
import {
  Multilang,
  MultilangString,
} from "../../../../models/product/multilang-string"
import {
  Action,
  Reducer,
  ReducersMapObject,
} from "../../../../utils/combine-reducer"
import { ITreeNode, ITreeState } from "../../../../utils/tree/interfaces"
import { IProductFormActionTypesAndValues } from "../../_actions"

export type DropdownOptionRawValue = MultilangString | DropdownOptionValue
export type DropdownOptionValue =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | boolean[]
  | object
  | object[]
  | undefined

export enum FormFieldTypes {
  Input = "input",
  Number = "number",
  Dropdown = "select",
  Checkbox = "checkbox",
  Blank = "placeholder",
  Search = "search",
  Textarea = "textArea",
  Rate = "rate",
  Date = "date",
  // Must be handled by custom created component
  Custom = "custom",
}

export interface IDropdownOption<
  T extends DropdownOptionRawValue = DropdownOptionRawValue
> {
  key: number | string
  text: string
  value: T
}

export enum FieldFamily {
  TECH_FIELD = "TECH_FIELD",
  STANDARD_FIELD = "STANDARD_FIELD",
}

export interface ICreateField<T extends FieldDataType> {
  code: string
  label: string
  dataType: T
  formFieldType?: FormFieldTypes
  defaultValue?: any
  localized?: boolean
  fieldType?: FieldType
  isRequired?: boolean
  isDeclinable?: boolean
  modified?: boolean
  lock?: LockStatus
  options?: IDropdownOption[]
}

type valueof<T> = T[keyof T]
export type FieldDataType = valueof<typeof FieldDataType>
export const FieldDataType = {
  FileList: [] as IFileDetails[],
  Text: "" as string,
  Boolean: false as boolean,
  Node: { name: "", id: "0", code: "" } as ITreeNode,
  Dropdown: {} as DropdownOptionRawValue,
  TreeState: { checked: [], expanded: [] } as ITreeState,
  Tax: [] as ITax[],
  Date: new Date() as Date,
  Number: 0 as number,
  MultiLang: Multilang.String.CreateNew(),
}

// prettier-ignore
export interface IFieldReducers<T extends FieldDataType>{
  code: Reducer<string, Action<IProductFormActionTypesAndValues>>
  label: Reducer<string, Action<IProductFormActionTypesAndValues>>
  errorText: Reducer<string, Action<IProductFormActionTypesAndValues>>
  value: Reducer<T, Action<IProductFormActionTypesAndValues>>
  modified: Reducer<boolean, Action<IProductFormActionTypesAndValues>>
  localized: Reducer<boolean, Action<IProductFormActionTypesAndValues>>
  isRequired: Reducer<boolean, Action<IProductFormActionTypesAndValues>>
  isDeclinable: Reducer<boolean, Action<IProductFormActionTypesAndValues>>
  formFieldType: Reducer<FormFieldTypes, Action<IProductFormActionTypesAndValues>>
  fieldType: Reducer<FieldType, Action<IProductFormActionTypesAndValues>>
  regenerateInfos: Reducer<ICreateField<T>, Action<IProductFormActionTypesAndValues>>
  options: Reducer<IDropdownOption[], Action<IProductFormActionTypesAndValues>>
  lock: Reducer<LockStatus, Action<IProductFormActionTypesAndValues>>
}
// export interface IFieldReducers<T extends FieldDataType> {
//   code: Reducer<any, any>
//   label: Reducer<any, any>
//   errorText: Reducer<any, any>
//   value: Reducer<any, any>
//   modified: Reducer<any, any>
//   localized: Reducer<any, any>
//   isRequired: Reducer<any, any>
//   formFieldType: Reducer<any, any>
//   fieldType: Reducer<any, any>
//   regenerateInfos: Reducer<any, any>
//   options: Reducer<any, any>
//   lock: Reducer<any, any>
// }

type StateFromReducersMapObject<M> = {
  [P in keyof M]: M[P] extends Reducer<infer S, any> ? S : never
}

export type IFieldState<T extends FieldDataType> = StateFromReducersMapObject<
  IFieldReducers<T>
>

export const CreateMockedFieldState = <T extends FieldDataType>(
  value: T,
  fieldType: FormFieldTypes
): IFieldState<T> => ({
  code: "",
  errorText: "",
  fieldType: FieldType.Standard,
  formFieldType: fieldType,
  isDeclinable: false,
  isRequired: false,
  label: "",
  localized: false,
  lock: "unlock",
  modified: false,
  options: [],
  regenerateInfos: undefined as any,
  value,
})

console.log({ FormFieldTypes })

export const patternFormFieldTypeMatch = {
  [CaratechType.text]: FormFieldTypes.Input,
  [CaratechType.select]: FormFieldTypes.Dropdown,
  [CaratechType.bool]: FormFieldTypes.Checkbox,
  [CaratechType.date]: FormFieldTypes.Dropdown,
  [CaratechType.number]: FormFieldTypes.Number,
}

export const patternDataTypeMatch = {
  [CaratechType.text]: FieldDataType.Text as FieldDataType,
  [CaratechType.select]: FieldDataType.Number as FieldDataType,
  [CaratechType.bool]: FieldDataType.Boolean as FieldDataType,
  [CaratechType.date]: FieldDataType.Number as FieldDataType,
  [CaratechType.number]: FieldDataType.Number as FieldDataType,
}

export const getDefaultCaratechValue = (
  type: CaratechType,
  isDeclinable: boolean
) => {
  switch (type) {
    case CaratechType.text:
      return isDeclinable ? "" : Multilang.String.CreateNew()
    case CaratechType.select:
      return "-1"
    case CaratechType.bool:
      return false
    case CaratechType.date:
      return -1
    case CaratechType.number:
      return ""
    default:
      return ""
  }
}

export default ICreateField
